<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div class="d-flex">
    <div class="d-flex align-center py-4 pb-6">
      <span class="text-h3 font-weight-bold"><slot/></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageSubHeader',
  }
</script>

<style scoped>

</style>
